// https://github.com/rjsf-team/react-jsonschema-form/blob/master/packages/material-ui/src/FieldTemplate/FieldTemplate.tsx
import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { FieldTemplateProps } from '@rjsf/core';
import WrapIfAdditional from './WrapIfAdditional';

const FieldTemplate: React.FC<React.PropsWithChildren<FieldTemplateProps>> = ({
  id,
  children,
  classNames,
  disabled,
  displayLabel,
  hidden,
  label,
  onKeyChange,
  readonly,
  required,
  rawErrors = [],
  rawHelp,
  rawDescription,
  schema,
  uiSchema,
}: FieldTemplateProps) => {
  if (hidden) {
    return children;
  }

  const isRequired = uiSchema && !!uiSchema['ui:softRequired'] ? true : required;
  const error = !!rawErrors.length;

  return (
    <WrapIfAdditional
      classNames={classNames}
      disabled={disabled}
      id={id}
      label={label}
      onKeyChange={onKeyChange}
      readonly={readonly}
      required={isRequired}
      schema={schema}
    >
      <FormControl
        fullWidth={true}
        error={error}
        required={isRequired}
        className={classNames}
        data-testid="field-template"
      >
        {children}
        {displayLabel && rawDescription ? (
          <Typography variant="caption" color="textSecondary">
            {rawDescription}
          </Typography>
        ) : null}
        {rawErrors.length > 0 && (
          <List dense={true} disablePadding={true}>
            {rawErrors.map((error, i: number) => {
              return (
                <ListItem key={i} disableGutters={true}>
                  <FormHelperText id={id}>{error}</FormHelperText>
                </ListItem>
              );
            })}
          </List>
        )}

        {rawHelp && <FormHelperText id={id}>{rawHelp}</FormHelperText>}
      </FormControl>
    </WrapIfAdditional>
  );
};

export default FieldTemplate;
